import { render, staticRenderFns } from "./ShowSubstudiesModal.vue?vue&type=template&id=1dfb2227&"
import script from "./ShowSubstudiesModal.vue?vue&type=script&lang=js&"
export * from "./ShowSubstudiesModal.vue?vue&type=script&lang=js&"
import style0 from "./ShowSubstudiesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports